import { render, staticRenderFns } from "./PromotionManagementByProperty.vue?vue&type=template&id=81432f04&"
import script from "./PromotionManagementByProperty.vue?vue&type=script&lang=js&"
export * from "./PromotionManagementByProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports